import React from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { Col, Form } from "react-bootstrap";

import {
    getFormattedPhoneNumber,
    isValidEmail,
    isValidPhoneNumber,
} from "../utils/utils";

const SubVendorAdditionalInfoFields = ({ prefix }) => {
    const {
        register,
        formState: { errors },
        setValue,
    } = useFormContext();

    const updatePhoneNumber = (e, field) => {
        const number = getFormattedPhoneNumber(e.target.value);
        setValue(field, number);
    };

    return (
        <>
            <Form.Group as={Col} md={6} className="mb-3">
                <Form.Label>Main Contact Name</Form.Label>
                <Form.Control
                    type="text"
                    size="lg"
                    {...register(`${prefix}_contact_name`)}
                />
            </Form.Group>

            <Form.Group as={Col} md={6} className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                    type="tel"
                    maxLength="14"
                    size="lg"
                    {...register(`${prefix}_phone`, {
                        onChange: e => updatePhoneNumber(e, `${prefix}_phone`),
                        validate: value =>
                            isValidPhoneNumber(value) ||
                            "Invalid phone number format.",
                    })}
                    isInvalid={!!errors[`${prefix}_phone`]}
                />
                {errors[`${prefix}_phone`]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors[`${prefix}_phone`].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group as={Col} md={6} className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                    type="email"
                    size="lg"
                    {...register(`${prefix}_email`, {
                        validate: value =>
                            isValidEmail(value) || "Invalid email format.",
                    })}
                    isInvalid={!!errors[`${prefix}_email`]}
                />
                {errors[`${prefix}_email`]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors[`${prefix}_email`].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </>
    );
};

SubVendorAdditionalInfoFields.propTypes = {
    prefix: PropTypes.string.isRequired,
};

export default SubVendorAdditionalInfoFields;
